import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { hardBaseUrl } from "../../services/urlConstant";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
    borderTop: "1px solid #e1e1e1",
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    padding: "10px 28px 10px 28px",
    backgroundColor: "black",
    color: "white",
    width: "213px",
    height: "40px",
    borderRadius: "6px",
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  },
  title: {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "32px",
  },
  subtitle: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "28px",
  },
  breadcrumbs: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#111827",
  },
  breadCrumbsActive: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#687083",
  },
  pagination: {
    "& .Mui-selected": {
      backgroundColor: "black",
      color: "white",
    },
  },
  pageSize: {
    height: "30px",
    borderRadius: "6px",
    border: "1px solid #D1D5DC",
    paddingLeft: "5px",
    paddingRight: "5px",
    marginTop: "5px",
  },
  paginationText: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
  },
  boxContent: {
    border: "1px solid #D1D5DC",
    padding: "16px",
    borderRadius: "8px",
  },
  buttonSave: {
    height: "44px",
    marginTop: "20px",
    width: "fit-content",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    backgroundColor: "black",
    color: "white",
    textTransform: "none",
  },
  textButtonSave: {
    color: "white",
    fontSize: "14px",
  },
  capitalize: {
    textTransform: "capitalize",
  },
}));

function FooterLandingPage() {
  const classes = useStyles();
  const [data, setData] = useState({
    listContent: [],
    loading: false,
  });

  const { listContent } = data;
  const changeValue = (key, value) =>
    setData(currentState => ({
      ...currentState,
      [key]: value,
    }));

  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const getData = () => {
    const url = `${hardBaseUrl}/landing-page/module/footer`;
    axios
      .get(url, config)
      .then(res => changeValue("listContent", res?.data?.data || []))
      .catch(err => new Error(err));
  };

  const submitValue = data => {
    const value = {
      module: "footer",
      data: data,
    };
    const url = `${hardBaseUrl}/landing-page/update`;
    axios
      .post(url, value, config)
      .then(() =>
        Swal.fire({
          icon: "success",
          title: "Success",
        }).then(() => {
          getData();
        })
      )
      .catch(err => new Error(err));
  };

  const handleChange = (key, e) => {
    const newData = [...listContent];
    const filteredData = [...newData]?.filter(({ id }) => id !== key);
    const getDataByKey = [...listContent]?.find(({ id }) => id === key);
    const newValue = {
      ...getDataByKey,
      url: e?.target?.value,
    };
    changeValue("listContent", [...filteredData, newValue] || []);
  };

  useEffect(() => {
    getData();
  }, []);

  const sizeOfBoxContent = listContent?.length > 1 ? 7 : 6;
  const spaceBetweenContent = listContent?.length > 1 ? 2 : 0;
  const sortData = (listContent || [])?.sort((a, b) => a?.id - b?.id);
  return (
    <Grid container direction="column">
      <Grid item xs={4} md={4} sm={4} lg={8} xl={8}>
        <Typography variant="h3" className={classes.title}>
          Footer
        </Typography>
        <p
          style={{
            marginTop: "5px",
            color: "#8f8f8f",
            fontSize: "14px",
          }}
        >
          This page is for manage & settings the content content
        </p>
      </Grid>
      <Grid
        className={classes.boxContent}
        item
        xs={sizeOfBoxContent}
        md={sizeOfBoxContent}
        sm={sizeOfBoxContent}
        lg={sizeOfBoxContent}
        xl={sizeOfBoxContent}
      >
        <Grid container spacing={spaceBetweenContent}>
          {sortData?.map(({ id, type, url }, index, currentData) => {
            const isLastIndex = index + 1 === currentData?.length;
            const sizeGrid = isLastIndex && index % 2 === 0 ? 12 : 6;
            const capitalizeType =
              (type || "").charAt(0)?.toUpperCase() + type?.slice(1);
            return (
              <Grid
                item
                key={id || index}
                xs={sizeGrid}
                md={sizeGrid}
                sm={sizeGrid}
                lg={sizeGrid}
                xl={sizeGrid}
              >
                <Typography>{`Link ${capitalizeType} Video`}</Typography>
                <TextField
                  variant="outlined"
                  onChange={value => handleChange(id, value)}
                  name="name"
                  size="medium"
                  id="formatted-numberformat-input"
                  value={url}
                  margin="dense"
                  fullWidth={true}
                  placeholder={`Link ${capitalizeType} Video`}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className={classes.suffix}>
                        .com
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Button
        variant="contained"
        className={classes.buttonSave}
        onClick={() => submitValue(listContent)}
      >
        <Typography className={classes.textButtonSave}>Save</Typography>
      </Button>
    </Grid>
  );
}

export default FooterLandingPage;
